import { useQuery } from "@tanstack/react-query";
import { economicNexusApi } from "../api/economicNexusApi";

export const useEconomicNexus = (year, quarterId) => {
  return useQuery({
    queryKey: ["economicNexus", year, quarterId],
    queryFn: () => economicNexusApi.getEconomicNexus({ year, quarterId }).then(res => res.data.result),
    enabled: !!year && quarterId > 0,
  });
};
